
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[[...params]]",
      function () {
        return require("private-next-pages/c/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[[...params]]"])
      });
    }
  